<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">

                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header title="Videos"></app-sub-header>

                    </div>

                </div>

                <div class="row">
                    <div class="col-md-12">
                        <form [formGroup]="form" (ngSubmit)="formRequest()" autocomplete="off" autocomplete="off">
                            <div class="mt-3" style="min-height: 274px;">

                                <div class="form-group">
                                    <select class="form-control" formControlName="type" (change)="setRegrex($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.type.errors }">
                                        <option value="">Select Video Type</option>
                                        <option *ngFor="let props of videoType" [value]="props.name">{{props.value}}
                                        </option>
                                    </select>

                                    <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
                                        <div style="text-align: right;" *ngIf="f.type.errors.required">
                                            {{errorMessage}}</div>

                                    </div>

                                </div>

                                <!-- <div class="form-group">
                                    <input type="text" formControlName="title" placeholder="Video Title"
                                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.title.errors }">

                                    <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                                        <div style="text-align: right;" *ngIf="f.title.errors.required">
                                            {{errorMessage}}</div>

                                    </div>
                                </div> -->


                                <div class="form-group mt-4">
                                    <input type="text" formControlName="videoUrl" placeholder="Add Url"
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.videoUrl.errors }">
                                    <div *ngIf="submitted && f.videoUrl.errors" class="invalid-feedback">
                                        <div style="text-align: right;" *ngIf="f.videoUrl.errors.required">
                                            {{errorMessage}}</div>
                                        <div style="text-align: right;" *ngIf="f.videoUrl.errors.pattern">
                                            Please enter a valid url.</div>
                                    </div>
                                </div>

                                <div class="form-group">

                                    <div class="display justify-content">
                                        <div class="date-box">
                                            <div>Do you want to display this video on Affilated users slider?</div>
                                        </div>

                                        <div class="cal">
                                            <div>
                                                <div class="switch_box box_1">
                                                    <input type="checkbox" class="switch_1" [checked]="checkboxValue"
                                                        (click)="getValue($event)" [value]="checkboxValue">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>


                                <!-- <div class="form-group">
                                    <label class="btn-bs-file btn btn-lg main-backgroundcolor color">
                                        Choose Thumbnail for Video
                                        <input type="file" (change)="uploadBanner($event)" />
                                    </label>

                                </div> -->

                                <div class="upload-image" *ngIf="thumbnailUrl">
                                    <div class="image-wrapper"
                                        style="width: '250px'; height: '140px'; border-radius: 0px;">
                                        <img [src]="renderImage(thumbnailUrl)" alt="Cover-Pic" width="" height="">
                                    </div>
                                </div>

                            </div>

                            <button *ngIf="videoId == undefined" type="submit"
                                class="btn color btn-lg btn-block main-backgroundcolor">Add</button>
                            <button *ngIf="videoId != undefined" type="submit"
                                class="btn color btn-lg btn-block main-backgroundcolor">Update</button>

                        </form>

                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
